import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import BackButton from "../../components/BackButton";
import TitleRecordFunction from "../../components/TitleRecordFunction";
import api from '../../api/manage_database/LocationReq';
import { useLocation } from "react-router-dom";
import { toast } from 'sonner';
import { FaSave } from "react-icons/fa";
import Spinner from "../../components/Spinner";
import handleChange from "../../utils/handleChange";
import InputPlace from "../../components/InputPlace";
import InputThoroughfare from "../../components/InputThoroughfare";
import SelectLocationTypeLine from "../../components/SelectLocationTypeLine";

const LocationRecord = () => {

    const locationApp = useLocation();

    const addRecordMessage = locationApp.state?.addRecordMessage;
    const deleteRecordMessage = locationApp.state?.deleteRecordMessage;
    
    const isViewRecord = locationApp.state?.anotherTypeOfPage === undefined;
    
    const { location_id } = useParams();
    
    const deletedLocation = locationApp.state?.data;

    const [editState, setEditState] = useState(false);

    const [place, setPlace] = useState('');
    const [thoroughfare, setThoroughfare] = useState('');
    const [locationTypeline, setLocationTypeLine] = useState('');
    const [locationTypeLines, setLocationTypeLines] = useState([]);
    const [selectedLocationTypeLine, setSelectedLocationTypeLine] = useState('');

    const [updatingRecordState, setUpdatingRecordState] = useState(false);

    const handleEditButton = () => {
        setEditState(prev => !prev);
    }

    const handleSaveButton = async () => {
        setUpdatingRecordState(true);
        const toastId = toast('');
        toast.loading('Updating Location record...', {id: toastId});
        try {
            const response = await api.put(
                '/record',
                {
                    id: location_id,
                    place: place,
                    thoroughfare: thoroughfare,
                    type_line: selectedLocationTypeLine,
                },
                {
                    withCredentials: true
                }
            );
            if (response.data.success) {
                toast.success(response.data.message, {id: toastId});
                setPlace(response.data.payload[0].place);
                setThoroughfare(response.data.payload[0].thoroughfare);
                setSelectedLocationTypeLine(response.data.payload[0].type_line);
                setLocationTypeLine(response.data.payload[0].type_line);
                setEditState(false);
            } else {
                toast.error(response.data.message, {id: toastId});
            }
        } catch (err) {
            toast.error(err.response?.data?.message || 'Could not update the location. Please try again.', {id: toastId});
        }
        setUpdatingRecordState(false);
    }

    useEffect(() => {
        const fetchLocationTypes = async () => {
                try {
                    const response = await api.get('type-lines', {withCredentials: true});
                    if (response.data.success) {
                        setLocationTypeLines(response.data.payload.type_lines);
                    } else {
                        toast.error('Not got data from database');
                    }
                } catch (err) {
                    console.log(err.response);
                }
            };
    
            fetchLocationTypes();
        }, []);

    useEffect(() => {
        const getLocationDescriptionData = async() => {
            let attempts = 0;
            while (attempts < 5) {
                try {
                    const response = await api.get(`record/${location_id}`, {withCredentials: true});
                    if (response.data.success) {
                        setPlace(response.data.payload[0].place);
                        setThoroughfare(response.data.payload[0].thoroughfare);
                        setSelectedLocationTypeLine(response.data.payload[0].type_line);
                        setLocationTypeLine(response.data.payload[0].type_line);
                        return
                    } else {
                        toast.warning('Not got data from database! trying again...');
                    }
    
                } catch (err) {
                    console.log(err.response);
                }

                attempts++;
                if (attempts < 5) {
                    await new Promise((res) => setTimeout(res, 2000));
                }
            }

            toast.error(`Data is not received after ${attempts} requests!`);
        };
        if (deletedLocation === undefined) {
            getLocationDescriptionData();
        } else {
            setPlace(deletedLocation.place);
            setThoroughfare(deletedLocation.thoroughfare);
            setLocationTypeLine(deletedLocation.type_line);
        }
    }, []);
    
    return (
        <div className='location-record-container'>
            <div className="location-record-title-wrapper">
                <TitleRecordFunction
                    addRecordMessage={addRecordMessage}
                    deleteRecordMessage={deleteRecordMessage}
                    title='Location'
                    isViewRecord={isViewRecord}
                />
                {deletedLocation === undefined ? 
                    !editState ?
                        <button
                            className='location-record-edit-button'
                            onClick={handleEditButton}
                        >   Edit
                        </button> :
                        <button
                            className='location-record-save-button'
                            onClick={handleSaveButton}
                        >   Save &nbsp; <FaSave />
                        </button>
                : null}
            </div>
            {updatingRecordState ? <Spinner /> :
                <table className='location-record-table-style'>
                    {
                    editState ? 
                        <tbody>
                            <tr>
                                <td>Place:</td>
                                <td>
                                    <InputPlace 
                                        place={place}
                                        handleInputPlace={handleChange(setPlace)}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td>Section:</td>
                                <td>
                                    <InputThoroughfare 
                                        thoroughfare={thoroughfare}
                                        handleInputThoroughfare={handleChange(setThoroughfare)}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td>Type Line:</td>
                                <td>
                                    <SelectLocationTypeLine
                                        LocationTypeLines={locationTypeLines}
                                        selectedlocationTypeLine={selectedLocationTypeLine}
                                        setSelectedLocationTypeLine={setSelectedLocationTypeLine}
                                    />
                                </td>
                            </tr>                            
                        </tbody> : 
                        <tbody>
                            <tr>
                                <td>Place:</td>
                                <td>{place}<br /></td>
                            </tr>
                            <tr>
                                <td>Section:</td>
                                <td>{thoroughfare}<br /></td>
                            </tr>
                            <tr>
                                <td>Type Line:</td>
                                <td>{locationTypeline}<br /></td>
                            </tr>                            
                        </tbody>
                    }       
                </table>
            }
            <BackButton
                navigateTo='/manage-database'
            />
        </div>
    )
}

export default LocationRecord;
